import { render, staticRenderFns } from "./new.vue?vue&type=template&id=2ace3eaf&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ace3eaf')) {
      api.createRecord('2ace3eaf', component.options)
    } else {
      api.reload('2ace3eaf', component.options)
    }
    module.hot.accept("./new.vue?vue&type=template&id=2ace3eaf&", function () {
      api.rerender('2ace3eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/users/new.vue"
export default component.exports